import React, { useMemo, useState } from "react";

import {
    ArrowLeftOutlined,
    CalculatorOutlined,
    SafetyCertificateOutlined
} from "@ant-design/icons";

import {
    useParams
} from "react-router-dom";

import {
    getMedicalTool
} from "./tools";

import {
    calculateMedicalTool
} from "./calculate";


export default function MedicalToolDetail() {

    const { slug } =
        useParams();

    const tool =
        getMedicalTool(slug);

    const [data, setData] =
        useState({});


    const result = useMemo(() => {

        if (!tool) {
            return null;
        }

        return calculateMedicalTool(
            tool.slug,
            data
        );

    }, [tool, data]);


    if (!tool) {

        return (

            <div className="max-w-screen-xl mx-auto px-4 pt-20 pb-10">

                <div className="bg-white border rounded-2xl p-8 text-center">

                    <p className="font-bold text-gray-800">

                        Không tìm thấy công cụ

                    </p>


                    <a
                        href="/tienich/cong-cu-y-khoa"
                        className="inline-block text-purple-600 font-semibold mt-3"
                    >

                        Quay lại bộ công cụ Y khoa

                    </a>

                </div>

            </div>
        );
    }


    const handleChange = (
        key,
        value
    ) => {

        setData(
            (current) => ({
                ...current,
                [key]: value
            })
        );
    };


    return (

        <div className="max-w-screen-xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">


            <a
                href="/tienich/cong-cu-y-khoa"
                className="inline-flex items-center text-purple-600 font-semibold text-sm mb-4"
            >

                <ArrowLeftOutlined className="mr-2" />

                Bộ công cụ Y khoa

            </a>


            <div className="bg-gradient-to-r from-violet-700 to-purple-500 rounded-2xl px-5 py-6 md:p-8 text-white">

                <div className="flex items-center">

                    <div className="w-12 h-12 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">

                        <CalculatorOutlined />

                    </div>


                    <div className="ml-4">

                        <p className="text-[11px] md:text-sm font-semibold opacity-90">

                            {tool.group}

                        </p>


                        <h1 className="text-[24px] md:text-3xl font-bold">

                            {tool.name}

                        </h1>

                    </div>

                </div>


                <p className="text-[14px] md:text-base mt-4 opacity-90 leading-6 max-w-3xl">

                    {tool.description}

                </p>

            </div>


            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">


                <div className="lg:col-span-2 bg-white border rounded-2xl p-4 md:p-6">

                    <h2 className="text-xl font-bold text-gray-900">

                        Nhập dữ liệu

                    </h2>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">

                        {tool.fields.map(
                            (field) => (

                                <div key={field.key}>

                                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                                        {field.label}

                                        {field.optional && (
                                            <span className="font-normal text-gray-400 ml-1">
                                                (không bắt buộc)
                                            </span>
                                        )}

                                    </label>


                                    {field.type === "select" ? (

                                        <select
                                            value={
                                                data[field.key] ??
                                                ""
                                            }
                                            onChange={(e) =>
                                                handleChange(
                                                    field.key,
                                                    e.target.value
                                                )
                                            }
                                            className="w-full h-12 border rounded-xl px-3 bg-white outline-none focus:border-purple-500"
                                        >

                                            <option value="">
                                                Chọn...
                                            </option>

                                            {field.options.map(
                                                (option) => (

                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >

                                                        {option.label}

                                                    </option>

                                                )
                                            )}

                                        </select>

                                    ) : (

                                        <div className="relative">

                                            <input
                                                type="number"
                                                step="any"
                                                value={
                                                    data[field.key] ??
                                                    ""
                                                }
                                                onChange={(e) =>
                                                    handleChange(
                                                        field.key,
                                                        e.target.value
                                                    )
                                                }
                                                className="w-full h-12 border rounded-xl px-3 pr-20 outline-none focus:border-purple-500"
                                                placeholder="Nhập giá trị"
                                            />


                                            {field.unit && (

                                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">

                                                    {field.unit}

                                                </span>

                                            )}

                                        </div>

                                    )}

                                </div>

                            )
                        )}

                    </div>


                    <button
                        type="button"
                        onClick={() =>
                            setData({})
                        }
                        className="mt-5 text-sm text-gray-500 font-semibold"
                    >

                        Xóa dữ liệu đã nhập

                    </button>

                </div>


                <div>

                    <div className="bg-white border rounded-2xl p-4 md:p-5">

                        <p className="text-sm font-semibold text-gray-500">

                            Kết quả

                        </p>


                        {result ? (

                            result.text ? (

                                <p className="font-semibold text-gray-700 leading-6 mt-3">

                                    {result.text}

                                </p>

                            ) : (

                                <>

                                    <div className="flex items-end flex-wrap mt-2">

                                        <p className="text-4xl font-bold text-purple-700">

                                            {Number(result.value).toFixed(
                                                result.decimals ?? 2
                                            )}

                                        </p>


                                        {result.unit && (

                                            <span className="text-sm text-gray-500 ml-2 mb-1">

                                                {result.unit}

                                            </span>

                                        )}

                                    </div>


                                    {result.detail && (

                                        <p className="text-[13px] text-gray-500 mt-3">

                                            {result.detail}

                                        </p>

                                    )}

                                </>

                            )

                        ) : (

                            <p className="text-[13px] text-gray-400 leading-5 mt-3">

                                Điền đủ các trường cần thiết để hiển thị kết quả.

                            </p>

                        )}

                    </div>


                    <div className="bg-gray-50 border rounded-2xl p-4 md:p-5 mt-3">

                        <p className="font-bold text-gray-800 text-sm">

                            Công thức

                        </p>

                        <p className="text-[13px] text-gray-600 leading-5 mt-2">

                            {tool.formula}

                        </p>

                    </div>

                </div>

            </div>


            <div className="bg-amber-50 border border-amber-100 rounded-2xl p-4 mt-5">

                <div className="flex items-start">

                    <SafetyCertificateOutlined className="text-amber-600 text-xl mt-0.5" />


                    <p className="text-[13px] text-gray-600 leading-6 ml-3">

                        Công cụ này hỗ trợ tính toán và tham khảo.
                        Không sử dụng kết quả đơn lẻ để tự chẩn đoán,
                        điều chỉnh thuốc hoặc quyết định xử trí cấp cứu.
                        Hãy kiểm tra đúng đơn vị, đối tượng áp dụng
                        và bối cảnh lâm sàng trước khi sử dụng.

                    </p>

                </div>

            </div>

        </div>
    );
}
